/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {NavItem} from '../header/nav-item';

@Pipe({
    name: 'navToMenuItem',
    standalone: false
})
export class NavToMenuItemPipe implements PipeTransform {
    transform(navItems: NavItem[] | null | undefined): MenuItem[] {
        if (!navItems || !Array.isArray(navItems)) {
            return [];
        }
        return navItems.map((item) => this.toMenuItem(item));
    }

    private toMenuItem(nav: NavItem): MenuItem {
        const item: MenuItem = {
            label: nav.label,
            icon: nav.icon,
            routerLink: nav.routerLink,
            url: nav.url,
            target: nav.target,
            separator: nav.separator,
            styleClass: nav.styleClass ?? nav.class,
            id: nav.id ?? nav.key,
            items: nav.items?.length ? nav.items.map((child) => this.toMenuItem(child)) : undefined
        };
        return item;
    }
}
